import { MenuItem, TextField } from "@mui/material";
import { SxProps } from "@mui/material/styles";

export type WorkSelectOption<Id extends string | number> = {
  id: Id;
  label: string;
};

// 一覧画面の工事絞り込みセレクタ。works マスタ(number id)と工事案件(uuid string)の両方で使う。
// allLabel 指定時は空値を「すべて」等の選択可能な選択肢として出す。
// placeholder 指定時は空値を無効プレースホルダとして常時表示する(未選択状態の説明)。
// どちらも未指定で選択肢が無い場合は「工事未登録」を出す。
export function WorkSelectField<Id extends string | number>({ options, value, onChange, allLabel, placeholder, sx }: {
  options: WorkSelectOption<Id>[];
  value: Id | "";
  onChange: (v: Id | "") => void;
  allLabel?: string;
  placeholder?: string;
  sx?: SxProps;
}) {
  // MUI Select は数値 value の MenuItem では onChange へ数値を、空文字 MenuItem 併存時などは
  // 文字列を渡すことがある。id の型(number/uuid string)に依存せず一致させるため String 比較する。
  const handleChange = (raw: string | number) => {
    const hit = options.find((o) => String(o.id) === String(raw));
    if (hit !== undefined) {
      onChange(hit.id);
      return;
    }
    onChange("");
  };
  const selectedValue = options.some((o) => o.id === value) ? value : "";
  return (
    <TextField select size="small" label="工事" sx={{ minWidth: 260, ...sx }}
      value={selectedValue} onChange={(e) => handleChange(e.target.value)}>
      {allLabel != null && <MenuItem value="">{allLabel}</MenuItem>}
      {allLabel == null && placeholder != null && <MenuItem value="" disabled><em>{placeholder}</em></MenuItem>}
      {allLabel == null && placeholder == null && options.length === 0 && <MenuItem value=""><em>工事未登録</em></MenuItem>}
      {options.map((o) => <MenuItem key={o.id} value={o.id}>{o.label}</MenuItem>)}
    </TextField>
  );
}
